export const VipBadge = () => (
  <div
    className="tw-absolute tw-left-0 tw-top-0 tw-flex tw-h-[28px] tw-w-[60px] tw-items-center tw-justify-center tw-gap-[8px] tw-rounded-br-[20px] tw-bg-[#FFBD2D]"
    style={{ filter: 'drop-shadow(0 0 6px rgba(0, 0, 0, 0.25))' }}
  >
    <span className="tw-font-jost tw-text-[12px] tw-font-semibold tw-uppercase tw-text-black">VIP</span>
  </div>
);
